const my_profile = {
  viewMyClubSeacretProfile: "Ver mi perfil de ClubSeacret", // translated
  verifiedEmail: "Correo electrónico verificado", // translated
  unverifiedEmail: "E-mail no verificado", // translated
  viewMoreDetails: "Ver más detalles", // translated
  createdFrom: "Creado desde", // translated
  createdTo: "Creado hasta", // translated
  selectStatus: "Seleccionar estado...", // translated
  searchByTitle: "Buscar por título...", // translated
  pushNotifications: "Notificaciones Push",
  pushNotificationsDescription: "Recibir notificaciones del navegador para actualizaciones y eventos importantes",
  pushNotificationsNotSupported: "Las notificaciones push no son compatibles con este navegador",
  pushNotificationsDeniedMessage: "Se denegó el permiso de notificación. Por favor, habilite las notificaciones en la configuración de su navegador para recibir notificaciones push.",
  pushNotificationsEnabled: "Notificaciones push habilitadas exitosamente",
  pushNotificationsDisabled: "Notificaciones push deshabilitadas exitosamente",
  userInformationMissing: "Falta información del usuario",
  failedToUpdatePushNotifications: "Error al actualizar la configuración de notificaciones push",
  notificationPermissionDenied: "Se denegó el permiso de notificación. Por favor, habilítelo en la configuración de su navegador.",
  notificationPermissionRequired: "Se requiere permiso de notificación para habilitar notificaciones push",
  notSupported: "No compatible",
  permissionDenied: "Permiso denegado",
  permissionNotRequested: "Permiso no solicitado",
  enabled: "Habilitado",
  disabled: "Deshabilitado",
};

export default my_profile;
